
import { apiClient } from '../../client'

export interface TopRowFirstCardData {
  current_pcs: number
  last_pcs: number
  variants: number
}

export interface TopRowSecondCardData {
  current_at_risk: number
  last_at_risk: number
  variants: number
}

export interface TopRowThirdCardData {
  current_month: number
  last_month: number
  pct_variance_vs_last_month: number
}

export interface TopRowFourthCardData {
  current_month: number
  last_month: number
  pct_variance_vs_last_month: number
}

export interface SecondRowFirstCardData {
  region: string
  total_expiring_value: number
}

export type SecondRowFirstCardDataArray = SecondRowFirstCardData[]

export interface SecondRowSecondCardData {
  store_id: number
  store: string
  city: string
  current_expiring_skus: number
  last_expiring_skus: number
  current_expiring_pcs: number
  last_expiring_pcs: number
  current_expiring_value: number
  last_expiring_value: number
}
export type SecondRowSecondCardDataArray = SecondRowSecondCardData[]

export interface ThirdRowFirstCardData {
  category: string
  total_expiring_value: number
}
export type ThirdRowFirstCardDataArray = ThirdRowFirstCardData[]

export interface ThirdRowSecondCardData {
  store_id: number
  city: string
  store: string
  current_expiring_skus: number
  last_expiring_skus: number
  current_expiring_pcs: number
  last_expiring_pcs: number
  current_expiring_value: number
  last_expiring_value: number
  category: string;
  brand: string;
  sku: string;
  current_expiring_stores: number;
  last_expiring_stores: number;
}

export type ThirdRowSecondCardDataArray = ThirdRowSecondCardData[]

export interface FreshnessHeroKpisResponse {
  topRowFirst: TopRowFirstCardData
  topRowSecond: TopRowSecondCardData
  topRowThird: TopRowThirdCardData
  topRowFourth: TopRowFourthCardData
}

function appendFilterParams(params: URLSearchParams, filters: any): void {
  if (!filters) return;

  const append = (key: string, value: any) => {
    if (Array.isArray(value) && value.length) {
      params.append(key, value.join(','));
    } else if (typeof value === 'string' && value.length) {
      params.append(key, value);
    } else if (value != null) {
      params.append(key, value.toString());
    }
  };

  append('client_ids', filters.client_ids);
  append('client_id', filters.client_id);

  append('category_ids', filters.category_ids);
  append('category_id', filters.category_id);

  append('subcategory_ids', filters.subcategory_ids);
  append('subcategory_id', filters.subcategory_id);

  append('brand_ids', filters.brand_ids);
  append('brand_id', filters.brand_id);
}

class FreshnessRepository {

  async getHeroKpis(filters?: any): Promise<FreshnessHeroKpisResponse> {
    const params = new URLSearchParams()
    appendFilterParams(params, filters)
    const queryString = params.toString()
    const url = `/business-kpi-dashboards/freshness/hero-kpis${queryString ? '?' + queryString : ''}`
    return apiClient.get(url)
  }

  async getExpiringByRegion(filters?: any): Promise<SecondRowFirstCardDataArray> {
    const params = new URLSearchParams();

    appendFilterParams(params, filters);

    const queryString = params.toString();
    const url = `/business-kpi-dashboards/freshness/expiring-by-region${queryString ? '?' + queryString : ''}`;
    return apiClient.get(url)
  }

  async getExpiringByStore(filters?: any): Promise<SecondRowSecondCardDataArray> {
    const params = new URLSearchParams();

    appendFilterParams(params, filters);


    const queryString = params.toString();
    const url = `/business-kpi-dashboards/freshness/expiring-by-store${queryString ? '?' + queryString : ''}`;
    return apiClient.get(url);
  }

  async getThirdRowFirstCard(): Promise<ThirdRowFirstCardDataArray> {
    return apiClient.get(`/business-kpi-dashboards/freshness/third-row-first-card`)
  }

  async getExpiringBySku(filters?: any): Promise<ThirdRowSecondCardDataArray> {
    const params = new URLSearchParams();

    appendFilterParams(params, filters);


    const queryString = params.toString();
    const url = `/business-kpi-dashboards/freshness/expiring-by-sku${queryString ? '?' + queryString : ''}`;
    return apiClient.get(url)
  }

}

export const freshnessRepository = new FreshnessRepository()

